import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Field } from "./Common";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

export function ClinicEditDialog({ clinic, onClose, onDone }) {
  const [f, setF] = useState({ name: "", owner_email: "" });
  useEffect(() => {
    if (clinic) setF({ name: clinic.name, owner_email: clinic.owner_email || "" });
  }, [clinic]);
  const save = async () => {
    try {
      await api.put(`/platform/clinics/${clinic.id}/details`, f);
      toast.success("Clinic updated"); onClose(); onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!clinic} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="clinic-edit-dialog">
        <DialogHeader><DialogTitle>Edit clinic</DialogTitle></DialogHeader>
        <Field label="Clinic name"><Input data-testid="clinic-edit-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></Field>
        <Field label="Owner email (their login)">
          <Input data-testid="clinic-edit-email" type="email" value={f.owner_email} onChange={(e) => setF({ ...f, owner_email: e.target.value })} />
        </Field>
        <p className="text-xs text-muted-foreground">
          The owner signs in with the new email and the same password. The clinic's web links (/{clinic?.slug}) stay the same.
        </p>
        <Button className="rounded-full" data-testid="clinic-edit-save" disabled={f.name.trim().length < 2 || !f.owner_email} onClick={save}>Save</Button>
      </DialogContent>
    </Dialog>
  );
}
